export default __webpack_public_path__ + "static/media/Ct7.7ab7c52f.png";